import React, { useContext } from 'react';
import { bool, func } from 'prop-types';
import * as R from 'ramda';
import { Box } from '@mui/material';

// Components
import Buttons from '../../components/Buttons';
import InventoryOwnerAutoComplete from '../../components/InventoryOwnerAutoComplete.connector';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const PrimaryStep1 = ({ loading, next, prev }) => {
  const {
    data,
    data: { currentAffiliate, inventoryOwners = [] },
    setData,
  } = useContext(SequencingWizardContext);

  const handleOnChange = val => {
    const update = { ...data, inventoryOwners: [val], loadProducts: true, products: [] };
    setData(update);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
        }}
      >
        <InventoryOwnerAutoComplete
          currentAffiliate={currentAffiliate}
          onChange={handleOnChange}
          selected={inventoryOwners[0]?.companyCustomerIdName}
          title="Which Inventory Owner should be primary?"
        />
      </Box>
      <Buttons
        disabled={R.isNil(inventoryOwners[0]?.companyCustomerIdName)}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={loading}
        rightLabel="Continue"
      />
    </>
  );
};

PrimaryStep1.propTypes = {
  loading: bool.isRequired,
  next: func.isRequired,
  prev: func.isRequired,
};

export default PrimaryStep1;
